export default __webpack_public_path__ + "static/media/spacequiz.ef3825e6.png";